import React from "react"
import Chronometer from 'app/components/Chronometer'
import DodoneEditModal from 'app/dodones/edit/Modal'
import { useMemo } from "react"

export default ({ dodone, onTick }) => {
  const hasChildren = dodone.children.length > 0;
  const attributesNames = useMemo(() => {
    const base = ['started_At']

    if(dodone.isTimeout)
      base.push('timeout')

    return base
  }, [dodone])

  return <DodoneEditModal attributesNames={ attributesNames }>
           <Chronometer startedAt={ dodone.startedAt }
                        size={ hasChildren ? 'small' : 'big' }
                        onTick={ onTick }
                        timeout={ dodone.timeout } />
         </DodoneEditModal>

}
